export default (params) => ({
  trigger: {
    name: 'live_chat.click_icon',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'microfrontend',
          'non-microfrontend',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'icon',
      },
    },
  },
});
